module.exports = __webpack_public_path__ + "static/image2-67aa4121d6acc84c7187a7e352756aa7.png";